export default __webpack_public_path__ + "static/media/logo_placeholder.7ce82699.svg";